<template>
 <div class="conversion-box">
   <div class="conversion">
    <div class="top">
      
      <el-form :model="formData" @submit.native.prevent label-width="70px" label-position="left"> 
        <FormItemComp :formState="root"/>
      </el-form>
      <div class="tip">
        <svg-icon icon-class='tip' class-name='tip-icon' />
        您可点击更新按钮进行获取最新的转化名称，请勿频繁点击，更新后无数据请前往媒体确认。
        <UpdateTimeButton 
          type="primary" 
          plain 
          :date="updateTime"
          size="mini"
          @click="handleUpdateNameList"
       />
      </div>
      <el-button type="primary" size="mini" @click="handleAddFormClick">+添加出价</el-button>
    </div>
    <div class="form-box" 
      id="infinite-form-box"
      v-loading="loading"
    >
		<template v-for="(item, index) in currentFormData">
			<ConversionForm  
				:key="item.id + currentKey" 
				:formData="item" 
				:index="index + 1"
			/>
		</template>
		
    </div>
    <div class="footer">
      <el-button @click="handleCloseClick">取消</el-button>
      <el-button type="primary" @keydown.enter.native.prevent @click="onSubmit" :loading="saveLoaing">保存</el-button>
    </div>
  </div>
 </div>
</template>

<script>
import { 
	getConversionNameListApi, updateConversionNameListApi, getBatchConversionPriceApi,
	getDeepConversionNameApi
 } from '@/api'
import UpdateTimeButton from '@/components/UpdateTimeButton'
import FormItemComp from '@/views/marketingManagement/configuration/formItemComp.vue'
import { createFormItemFactory, observableMap } from './create.js'
import { displayType,appList,materialType,placementType,searchConfigData , config } from './mock.js'
import ConversionForm from './conversionForm/index.vue'
import { ADD_TYPE } from '../../constant.js'
import { tipModal } from '../index.js'
import _ from 'lodash'
const defaultFormData = {
	way: '', // 出价方式
	price: '', // 出价
	strategy: '', // 投放策略
	deep: false, // 深度转化
	target: '', // 转化目标
	cost: '', // 期望转化成本
	deepCost: '', // 深度转化出价
	deepTarget: '', // 深度转化目标
	deepType: '', // 深度转化类型
}
export default {
	props: [ 'cbs', 'displayType', 'appList', 'config', 'account', 'configOpt', 'defaultSelectData','addType' ],
	components: { UpdateTimeButton, FormItemComp, ConversionForm },
	directives: {  },
	provide() {
		return {
			global: this,
			defaultFormData,
		}
	},
	data() {
		const displayTypeMap = observableMap(this.displayType, (item)=> ({...item,num: 0,}))
		const appListMap = observableMap(this.appList, (item)=> ({...item,num: 0,}));
		const selectData = this.defaultSelectData || {};
		const addType = this.addType || ADD_TYPE.POSITION;
		return {
			displayTypeMap,
			appListMap,
			updateTime: 0,
			formData: {},
			loading: false,
			saveLoaing: false,
			targetList: [],
			selectData,
			currentKey: '',
			currentAddType: addType,
			priceTypeList: [],//出价类型
			conversionNameList: {},//转化名称列表
			// currentFormData: [],
			cacheAvgPrice: new Map(),//缓存平均出价
			cacheDeepConversionName: {},//缓存深度转化名称列表
		}
	},
	computed: {
		isPosition() {
			return this.currentAddType ===ADD_TYPE.POSITION
		},
		currentFormData() {
			return this.selectData[this.currentKey] || [];
		},
		root() {
			return createFormItemFactory({ 
				displayType:  this.displayTypeMap,
				appList: this.appListMap, 
				vm: this
			})
		},
		appId() {
			if(this.isPosition) {
				return '';
			}
			const [ app_id ] = this.currentKey.split('_');
			return app_id;
		}
	},
	watch: {
	
	},
	created() {
		this.getConversionNameList()
	},
	mounted() {
		this.$nextTick(()=> {})
	},
	methods: {
		formDataChange(acients, formData) {
			const key = _.tail(acients).map(v=>v.payload.value).join('_');
			
			// 防止重复渲染
			if(this.currentKey === key) {
				return;
			}
			this.currentKey = key;
			this.formData = formData;
			const price_type = this.config.price_type;
			
			const keyDisplayType = _.keyBy(this.displayType, 'value')
			const priceTypeList = _.filter(price_type, { pid: keyDisplayType[formData.display_type].param_id  });
			this.priceTypeList = priceTypeList;
			if(!this.selectData[key]) {
				this.$set(this.selectData, key, [{ ..._.cloneDeep(defaultFormData), id: _.uniqueId() }]);
			}
			// this.currentFormData = this.selectData[key];
			this.currentAddType = _.head(acients).payload.value;
			if(this.currentAddType === ADD_TYPE.POSITION) {
				
			}
			// console.log(acients, key, targetList,formData, 'formDataformDataformData');
			this.updateFormOptionData()
		},
		updateFormOptionData() {
			const isP = this.currentAddType ===ADD_TYPE.POSITION;
			const [ app_id ] = this.currentKey.split('_');
			
			_.forEach(this.displayTypeMap, (item)=> {
				const data = this.selectData[ isP? `${item.value}` : `${app_id}_${item.value}` ];
				item.num =  data?.length || 1;
			});
			if (isP) {
				_.forEach(this.appListMap, (item)=>{
					item.num =   1;
				});
			}else {
				_.forEach(this.appListMap, (item)=>{
					item.num =  _.sumBy(this.displayTypeMap, (v)=> {
						const data = this.selectData[`${item.value}_${v.value}`];
						if (data) {
							return data.length;
						}else {
							return 1;
						}
					});
				});
			}
		},
		async getConversionNameList() {
			const params = {
				plat_id: 10,
				account_id: this.account,
				product_id: this.appList.map(v=> v.value),
				// tracking_type: ''
			}
			const { data } = await getConversionNameListApi(params);
			const groupData = _.groupBy(data, 'product_id');
			this.conversionNameList = groupData;
		},
		// 添加方式切换
		handleAddTypeBeforeChange({ newValue, oldValue }) {
			return new Promise((resolve, reject) => {
				this.$confirm('切换后已经修改的内容不会保存，确认要切换吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.selectData = {};
					this.updateFormOptionData()
					resolve()
				}).catch(reject);
			})
		},
		// 切换产品
		handleProductChange() {
			this.$nextTick(()=> {
			
			})
		},
		// 添加
		handleAddFormClick() {
			this.selectData[this.currentKey].push({ ..._.cloneDeep(defaultFormData), id: _.uniqueId() });
			this.updateFormOptionData()
		},
		
		
		onSubmit() {
			const keys = Object.keys(this.selectData);
			const ERROR_TYPE = {
				EMPTY: '1', // 没有填写的出价信息
				DUPLICATE: '2', // 存在相同的出价信息
				NOT_VALID: '3', // 出价信息不合法
			};
			const ERROR_TYPE_LIST = {
				[ERROR_TYPE.EMPTY]: [],
				[ERROR_TYPE.DUPLICATE]: [],
				[ERROR_TYPE.NOT_VALID]: [],
			};
			const displayTypeMap = _.mapValues(_.keyBy(this.displayType, 'value'), 'label');
			const appListMap = _.mapValues(_.keyBy(this.appList, 'value'), 'app_name');
			const keysAllValid = keys.reduce((pre,key)=> {
				const data = this.selectData[key];
				console.log(data,this.selectData, key , 'data');
				const checkData = {};
				const list = data.map(item=>{
					const validItem  = this.validateFormDataItem(item,  ERROR_TYPE);
					if(validItem) {
						return validItem;
					}
					const omitIData = _.omit(item, 'id');
					 const dataKey = JSON.stringify(omitIData);
					 if(checkData[dataKey]) {
						 return ERROR_TYPE.DUPLICATE;
					 }
					 checkData[dataKey] = true;
					return null;
				})
				pre[key] = list
				return pre 
			}, {});
			Object.keys(keysAllValid).forEach(key=> {
				const list = keysAllValid[key];
				list.forEach((item, index)=> {
					if(item) {
						let message = '';
						const [ app_id, display_type ] = key.split('_');
						if(this.isPosition) {
							message = displayTypeMap[app_id]
						}else {
							message = `${appListMap[app_id]}_${displayTypeMap[display_type]}`;
						}
						ERROR_TYPE_LIST[item].push(`${message}_第${index + 1}条`);
					}
				})
			});
			!(()=> {
				if(this.isPosition) {
					_.forEach(this.displayTypeMap, (item)=> {
						const data = this.selectData[item.value];
						if (!(data && data.length)) {
							ERROR_TYPE_LIST[ERROR_TYPE.EMPTY].push(`${item.label}_第1条`);
						}
					});
				}else {
					_.forEach(this.appListMap, (item)=> {
						_.forEach(this.displayTypeMap, (v)=> {
							const data = this.selectData[`${item.value}_${v.value}`];
							if (!(data && data.length)) {
								ERROR_TYPE_LIST[ERROR_TYPE.EMPTY].push(`${item.app_name}_${v.label}_第1条`);
							}
						})
					})
				}
			}) ();
			if(_.values(ERROR_TYPE_LIST).some(v=>v.length) ) {
				return tipModal({
					props: {
						tip: '',
						list: _.omitBy({
							'存在相同的出价信息': ERROR_TYPE_LIST[ERROR_TYPE.DUPLICATE],
							'没有填写的出价信息': ERROR_TYPE_LIST[ERROR_TYPE.EMPTY],
							'出价信息不合法': ERROR_TYPE_LIST[ERROR_TYPE.NOT_VALID],
						}, (v)=> !v.length),
					}
				})
			}
			this.cbs.onSubmit(this.selectData, this.currentAddType)
		},
		// 验证出价数据
		validateFormDataItem(item, ERROR_TYPE) {
			const { way, price, strategy,target, cost, deep, deepName, deepCost , deepType} = item;
			if(!way) {
				return ERROR_TYPE.EMPTY;
			}
			if(this.isPosition) {
				// 一阶出价
				if( way !== 'PRICING_OCPC') {
					if(!(price && ( +price > 0 && +price<1000000000))) {
						return ERROR_TYPE.NOT_VALID;
					}
					// 二阶出价
				}else if(!deep) {
					if(!(cost && ( +cost > 0 && +cost<1000000000)&&
					(this.appList.every(v=>item[v.value]))&&strategy)) {
						return ERROR_TYPE.NOT_VALID;
					}
					
					// 三阶出价
				}else {
					if(!(
						deepCost && ( +deepCost > 0 && +deepCost<1000000000)&&
						strategy&&
						(this.appList.every(v=>item[v.value])) &&
						(this.appList.every(v=>item[`deep_${v.value}`]))&&
						(this.appList.every(v=>item[`type_${v.value}`]))
					) ) {
						return ERROR_TYPE.NOT_VALID;
					}
				}
			}else {
				console.log(item, 'itemitemitemitem');
				// 一阶出价
				if( way!== 'PRICING_OCPC') {
					if(!(price && ( +price > 0 && +price<1000000000))) {
						return ERROR_TYPE.NOT_VALID;
					}
					// 二阶出价
				}else if(!deep) {
					if(!(cost && ( +cost > 0 && +cost<1000000000)&&
					strategy&&target)) {
						return ERROR_TYPE.NOT_VALID;
					}
					// 三阶出价
				}else {
					if(!(cost && ( +cost > 0 && +cost<1000000000)&&
						target&&
						deepCost && ( +deepCost > 0 && +deepCost<1000000000)&&
						strategy&&deepName&&deepType)) {
						return ERROR_TYPE.NOT_VALID;
					}
				}
			}
			return null;
		},
		// 关闭逻辑
		handleCloseClick() {
			this.$emit('close')
		},
		
		async handleUpdateNameList() {
			const vm = this.$notify({
				title: '请求成功',
				message: '正在更新，请稍等',
				type: 'success'
			});
			const params = {
				account_id: this.account,
				plat_id: 10,
				product_id: this.appList.map(v=> v.value),
			}
			try {
			await updateConversionNameListApi(params);
			await this.getConversionNameList();
			// this.$bus.$emit('updateName')
			this.$notify({
				title: '更新成功',
				message: '转化跟踪 更新成功',
				type: 'success'
			});
			} catch (error) {
			if (typeof error.data === "number" && error.data>0) {
				this.updateTime = error.data;
			}
			this.$notify({
				title: '更新失败',
				message: error.info || '更新失败',
				type: 'error'
			});
			console.log('转化名称更新失败',error);
			}
			if (vm) {
			vm.close()
			}
		},
		handleDelClick(id) {
			const list = this.selectData[this.currentKey];
			if (list.length <=1) {
				this.$message.error('至少需要一个出价');
				return;
			};
			const  index = _.findIndex(list, (item)=> item.id === id);
			if (index > -1) {
				list.splice(index, 1);
				this.updateFormOptionData()
			}
		},
		handleCopyClick(formData) {
			this.selectData[this.currentKey].push({
				...formData,
				id: _.uniqueId(),
			});
			this.updateFormOptionData()
		},
		// 出价均值
		async getBatchConversionPrice(query = {}) {
			const params = {
				account_id: this.account,
				plat_id: 10,
				creative_size_id: this.formData.display_type,
				product_id: this.appList.map(v=> v.value),
				...query
			};
			const mapKey = JSON.stringify(params);
			if(this.cacheAvgPrice.has(mapKey)){
				return this.cacheAvgPrice.get(mapKey);
			}
			const { data } = await getBatchConversionPriceApi(params);
			this.cacheAvgPrice.set(mapKey, data.list);
			return data.list;
		},
		async getDeepConversionName(query = {}) {
			const params = {
				account_id: this.account,
				plat_id: 10,
				...query
			}
			const mapKey = JSON.stringify(params.tracking_id);
			if(this.cacheDeepConversionName[mapKey]){
				return this.cacheDeepConversionName[mapKey];
			};
			this.$set(this.cacheDeepConversionName, mapKey, []);
			const { data } = await getDeepConversionNameApi(params);
			if (!data?.length ) {
				this.$set(this.cacheDeepConversionName, mapKey, null);
				return [];
			}
			this.$set(this.cacheDeepConversionName, mapKey, data);
		},
		handleValidNumber(num) {
			const value = num+'';
			if (value.indexOf('.')>-1) {
				const list = value.split('.');
				if (list[1].length>2) {
				return [list[0], list[1].slice(0,2)].join('.')
				}
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.tip-icon {
  font-size: 18px;
  margin-right: 4px;
}
.conversion-box {
  height: 100%;
  width: 100%;
  overflow-x: auto;
}
.conversion {
  padding: 0 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 1200px;
  .tip {
    margin-bottom: 10px;
  }
  .form-box {
    height: 0;
    flex: 1;
    overflow: auto;
    // background: red;
    margin-top: 16px;
  }
  .footer {
    height: 60px;
    line-height: 60px;
    text-align: right;
    padding-right: 80px;
    margin: 0 -20px;
    box-shadow: 4px 0 4px #ccc;
  }
}

</style>